import Filter from "../FilterByParameters/Filter";

class ModalColorizerSetupTools {

    getDataType(selectedOption, objectTypes) {
        let dataType = null;
        for (let option of objectTypes) {
            if (option.name === selectedOption) {
                dataType = option.data_type;
                break;
            }
        }
        return dataType;
    }

    getDataName(selectedOption, objectTypes) {
        let dataType = null;
        for (let option of objectTypes) {
            if (option.name === selectedOption) {
                dataType = option.name;
                break;
            }
        }
        return dataType;
    }

    // DEPRECATED
    // getSelectedPage(selectedOption: string, pageSelectors, objectTypes) {
    //     let selectedPage = pageSelectors[0];
    //     for (let page in pageSelectors) {
    //         // if (pageSelectors[page].includes(this.getDataType(selectedOption, objectTypes))) {
    //         if (pageSelectors[page].includes(this.getDataName(selectedOption, objectTypes))) {
    //             selectedPage = page;
    //             break;
    //         }
    //     }
    //     return selectedPage;
    // }

    getSelectedPage2(selectedOption: string, filter: Filter): [string, string] {
        if (filter.getTypeKeysColorableSlider().includes(selectedOption)) {
            return ['colorize_slider', selectedOption];
        }
        if (filter.getTypeKeysColorableGroup().includes(selectedOption)) {
            return ['colorize_group', selectedOption ];
        }

        console.debug('filter.getTypeKeysColorableSlider()', filter.getTypeKeysColorableSlider());
        console.debug('filter.getTypeKeysColorableGroup()', filter.getTypeKeysColorableGroup());
        console.debug('filter.getFilterItem: ', filter.getFilterItem(selectedOption));
        try {
            let firstOption = filter.getTypeKeysFirstPossible();
            let firstPage = this.getSelectedPage2( firstOption, filter)[0]
            console.warn('getSelectedPage2, unknown selectedOption: ', selectedOption,' - no problem, will be selected first possible form available: ', firstPage, firstOption);
            return [ firstPage, firstOption ];
        } catch (e) {
            alert('Nothing to show in slider or group colorizer. Please look at console.');
        }
    }

    _expandValuesBetter(px_min: number = 0, px_max: number = 200, px: number[] = [], width: number[] = [], max_elements: number | null = null, px_step = 3) {

        // console.debug('_expandValuesBetter, px_min, px_max, px, width', px_min, px_max, px); // #ROUND
        // const px_step = 6; // How many pixels change at once --- low better for quality --- keep number that can be divided by 2
        let new_distances: number[] = []; // New space between px elements
        let count_changes = 0;
        if (max_elements === null) max_elements = px.length;

        // Set initial new_distances
        for (let ii = 0; ii < max_elements - 1; ii++) {
            new_distances.push(px[ii + 1] - px[ii]);
        }

        // Add space where needed
        for (let ii = 0; ii < max_elements - 1; ii++) {
            if (typeof width[ii] !== 'number') width[ii] = 1; // Set default minimum width (for valid order)
            if (px[ii + 1] - px[ii] < width[ii]) {
                // Add some space between px
                const change_px = Math.max(Math.ceil(px_step / 2), 2);// Change by minimum 2px // #ROUND: uncomment this, delete next line
                // const change_px = 0.1;
                count_changes++;
                new_distances[ii] += px_step;
                px[ii] -= change_px;
                px[ii + 1] += change_px;
            }
        }

        // If something was changed here, make next iteration
        if (count_changes > 0) {
            // More changes, px_step should be bigger to fastest operation
            // px_step = Math.max(count_changes*2, 4);
            return this._expandValuesBetter(px_min, px_max, px, width, max_elements, px_step);
        } else {
            return px;
        }
    }


    getPlaceValuesBetter(px_min = 0, px_max = 200, px = [], width = [], max_elements: number | null = null, left_iteration = 29) {

        // console.debug('getPlaceValuesBetter(), px_min, px_max', px_min, px_max);
        // console.debug('getPlaceValuesBetter(), px', px);
        // console.debug('getPlaceValuesBetter(), width', width);

        left_iteration--;
        if (left_iteration <= 0) return px;

        // Get only valid numbers
        px = px.filter(v => !isNaN(v) && typeof v == 'number');
        if (max_elements === null) max_elements = px.length;

        // Get only valid numbers
        width = width.filter(v => !isNaN(v) && typeof v == 'number');

        // Try iterate
        let new_px = this._expandValuesBetter(px_min, px_max, px, width, max_elements);

        // Dont allow values below minimum, correct minimum, and make next iterations
        if (typeof new_px[0] == 'number' && new_px[0] < px_min) {
            new_px[0] = px_min;
            return this.getPlaceValuesBetter(px_min, px_max, new_px, width, max_elements, left_iteration);
        }

        // Dont allow values under maximum, correct max, and make next iterations
        if (typeof new_px[new_px.length - 1] == 'number' && new_px[new_px.length - 1] > px_max) {
            // console.log('getPlaceValuesBetter, exceded max,', new_px[new_px.length-1], px_max);
            new_px[new_px.length - 1] = px_max;
            return this.getPlaceValuesBetter(px_min, px_max, new_px, width, max_elements, left_iteration);
        }

        // Dont allow exceed maximum by any number (when last element is NaN)
        for (let ii = 0; ii < new_px.length; ii++) {
            if (typeof new_px[ii] == 'number' && new_px[ii] > px_max) {
                new_px[ii] = px_max;
                return this.getPlaceValuesBetter(px_min, px_max, new_px, width, max_elements, left_iteration);
            }
        }

        return new_px;
    }

}

export default ModalColorizerSetupTools;